<div class="flex items-center justify-center h-screen bg-opacity-80 bg-white fixed w-screen top-0 left-0 z-50">
  <ng-lottie [options]="options" width="200px" height="200px" />
</div>